import { simulateResize } from 'utils/resize';
import { getNodeScrollOffset } from 'utils/dom-helpers';

import { contentContainerId, sidebarContainerId, sidebarContentId } from './constants';

/**
 * this is a hack to preserve scroll position for FollowContainer in sidebar
 */
export const resetCatalogScroll = () => {
  const sidebarContainerNode = document.getElementById(sidebarContainerId);
  const sidebarContentNode = document.getElementById(sidebarContentId);

  /**
   * has sidebar: desktop rendering mode
   */
  if (sidebarContainerNode && sidebarContentNode) {
    const sidebarContainerTop = getNodeScrollOffset(sidebarContainerNode);
    const sidebarContentTop = getNodeScrollOffset(sidebarContentNode);

    /** first scroll up */
    let scrollTop = window.pageYOffset - sidebarContainerTop;
    window.scrollTo(0, scrollTop);

    /** then back down a little to restore previous sidebar position */
    requestAnimationFrame(() => {
      scrollTop += sidebarContentTop;
      window.scrollTo(0, scrollTop);
      simulateResize();
    });
    return;
  }

  /**
   * no sidebar: mobilegit  rendering mode
   */
  const contentNode = document.getElementById(contentContainerId);

  /** offset 400 is required to make it look like content is being scrolled smoothly */
  const contentTop = window.pageYOffset - getNodeScrollOffset(contentNode) + 400;
  if (window.pageYOffset > contentTop) {
    window.scrollTo(0, contentTop);
  }
};
